import { render, staticRenderFns } from "./SchemaEdit.vue?vue&type=template&id=7f246284&"
import script from "./SchemaEdit.vue?vue&type=script&lang=ts&"
export * from "./SchemaEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports